export enum HedgingInstrumentInterestRateMode {
  customTrade = 0,
  irSwap = 1,
  IrSwapWithEmbeddedFloor = 2,
  irCap = 5,
  irFloor = 6,
  crossCurrencySwap = 7,
  inflationSwap = 8,
  fxForward = 9,
  fxSwap = 10,
  fxForwardStrip = 11,
  fxOption = 12,
  fxAveragingForward = 14,
  swaption = 16,
  commoditySwap = 17,
  inflationWitPayGo = 18,
  commodityCall = 19,
  commodityPut = 20,
  commodityCollar = 21,
  irCollar = 22,
  fxForwardNDF = 23,
  irCapWithFixed = 24,
  irCollarWithPremium = 25,
}
